import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const AuthorGroups = React.lazy(() => import('./index'));
const AuthorGroupTable = React.lazy(() => import('./authorGroupTable'));
const AuthorGroup = React.lazy(() => import('./authorGroup'));
const AuthorGroupDetail = React.lazy(() => import('./authorGroupDetail'));
const AddNewAuthorGroup = React.lazy(() => import('./addNewAuthorGroup'));
const EditAuthorGroup = React.lazy(() => import('./editAuthorGroup'));

export const useAuthorGroupRoutes = () => {

    return (
        <Route path="authorGroups" element={<Suspense fallback={<div>منتظر باشید...</div>}><AuthorGroups /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AuthorGroupTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewAuthorGroup/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><AuthorGroup/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AuthorGroupDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditAuthorGroup/></Suspense> } />
            </Route>
        </Route>
    )
}